<template>
  <div class="row mx-0">
    <div class="col-5 bold row-header">
      {{ label }}
    </div>
    <div :class="['col-7', { 'text-right': isRight }]">
      <slot name="cell" />
    </div>
  </div>
</template>

<script>
import Mixin from '../mixin/Mixin'

export default {
  name: 'MobileCell',
  components: {},
  mixins: [Mixin],
  props: {
    /** 項目名 */
    label: {
      type: String,
      default: null,
    },

    /** 右寄せフラグ */
    isRight: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({}),

  methods: {},

  computed: {},
}
</script>

<style lang="sass"></style>



// WEBPACK FOOTER //
// src/components/base/MobileCell.vue